import React, { useEffect } from "react";
import { View, Card, Text, TouchableOpacity } from "react-native-ui-lib";
import { Col, CustomModal, CustomNumberInput, CustomSelect, CustomTextField, CustomUpload, DangerButton, Label, PrimaryButton, Row, SecondaryButton } from "../../mycomponents/DynamicForm";
import { Video, ResizeMode } from 'expo-av';
import { Dimensions, Platform, ScrollView } from "react-native";
import Svg, { Rect, Path } from "react-native-svg";

const VideoSvg = (props) => (
  <Svg
    _ngcontent-rnh-c220=""
    width={55}
    height={55}
    viewBox="0 0 55 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect _ngcontent-rnh-c220="" width={55} height={55} rx={6} fill="#EEF2FF" />
    <Path
      _ngcontent-rnh-c220=""
      d="M35.9448 35.9997C35.9448 36.2789 36.0557 36.5466 36.2531 36.744C36.4505 36.9414 36.7182 37.0523 36.9974 37.0523C37.2766 37.0523 37.5443 36.9414 37.7417 36.744C37.9391 36.5466 38.05 36.2789 38.05 35.9997C38.05 35.7206 37.9391 35.4528 37.7417 35.2554C37.5443 35.058 37.2766 34.9471 36.9974 34.9471C36.7182 34.9471 36.4505 35.058 36.2531 35.2554C36.0557 35.4528 35.9448 35.7206 35.9448 35.9997ZM26.9977 41C23.698 40.9995 20.4906 39.911 17.8721 37.903C15.2537 35.8951 13.3705 33.0798 12.514 29.8932C11.6576 26.7066 11.8758 23.3265 13.1349 20.2764C14.394 17.2264 16.6236 14.6766 19.4785 13.0221C22.3334 11.3675 25.6542 10.7005 28.9265 11.1243C32.1989 11.5481 35.2402 13.039 37.5794 15.3663C39.9186 17.6935 41.4251 20.7272 41.8657 23.9973C42.3062 27.2675 41.6562 30.5916 40.0163 33.455C39.8767 33.6973 39.6466 33.8742 39.3765 33.9469C39.1065 34.0195 38.8186 33.9819 38.5763 33.8423C38.334 33.7027 38.1571 33.4726 38.0844 33.2026C38.0118 32.9325 38.0494 32.6447 38.189 32.4024C39.7411 29.6908 40.256 26.5079 39.6379 23.4453C39.0198 20.3827 37.3107 17.6487 34.8284 15.7514C32.3461 13.8541 29.2593 12.9226 26.1418 13.13C23.0244 13.3374 20.0882 14.6697 17.8792 16.8792C15.6701 19.0886 14.3384 22.025 14.1315 25.1425C13.9246 28.26 14.8566 31.3466 16.7544 33.8286C18.6521 36.3106 21.3864 38.0191 24.4492 38.6367C27.5119 39.2543 30.6947 38.7389 33.4059 37.1862C33.5259 37.1171 33.6583 37.0723 33.7956 37.0544C33.9329 37.0364 34.0724 37.0457 34.2061 37.0817C34.3398 37.1176 34.4652 37.1796 34.5749 37.264C34.6847 37.3484 34.7768 37.4536 34.8459 37.5736C34.915 37.6936 34.9598 37.826 34.9778 37.9633C34.9957 38.1006 34.9864 38.2401 34.9504 38.3738C34.9145 38.5075 34.8525 38.6328 34.7681 38.7426C34.6837 38.8523 34.5785 38.9444 34.4585 39.0135C32.1874 40.3148 29.6152 40.999 26.9977 40.9983V41ZM24.1026 32.0916C23.6839 32.0916 23.2823 31.9253 22.9862 31.6292C22.6901 31.3331 22.5237 30.9315 22.5237 30.5127V21.7003C22.5235 21.423 22.5963 21.1506 22.7348 20.9103C22.8734 20.6701 23.0727 20.4706 23.3128 20.3319C23.553 20.1932 23.8254 20.1202 24.1027 20.1202C24.38 20.1202 24.6524 20.1932 24.8925 20.332L32.5243 24.7394C32.7642 24.878 32.9634 25.0773 33.1019 25.3173C33.2404 25.5573 33.3133 25.8295 33.3133 26.1065C33.3133 26.3836 33.2404 26.6558 33.1019 26.8958C32.9634 27.1357 32.7642 27.335 32.5243 27.4737L24.8925 31.8786C24.6525 32.0178 24.3801 32.0912 24.1026 32.0916ZM24.6289 22.6182V29.5999L30.6818 26.1078L24.6289 22.6182Z"
      fill="#1E7BE2"
    />
  </Svg>
);

export const coursefields = (response, view = false, moduleName = null, OpenModalCustom, value, isEdit, globalData, setGlobalData) => {

  const CourseContent = ({ field, useForm, tKey, tIndex }) => {
    let modules = useForm((state) => state.formObject['modules']) || [];
    const setFormObject = useForm((state) => state.setFormObject);
    const [showLessonModule, setShowLessonModule] = React.useState(false);
    const [lessonModuleIndex, setLessonModuleIndex] = React.useState(null);
    const [lessonIndex, setLessonIndex] = React.useState(null);

    return <View style={{
      width: '100%',
    }}>
      {modules.map((module, index) => {
        return <Card key={index} flex padding-15 style={{
          width: '100%',
          marginVertical: 10,
          flexDirection: 'row',
          flexWrap: 'wrap',
          minHeight: "auto"
        }}>
          <View style={{ width: '100%' }}>
            <View row={Platform.OS == 'web'} spread={Platform.OS == 'web'} style={{ width: '100%' }}>
              <View>
                {!view ? <CustomTextField placeholder="Module Name" value={module.name} onChange={(value) => {
                  const oldModules = [...modules];
                  oldModules[index].name = value;
                  setFormObject({
                    modules: oldModules
                  });
                }} /> : <Text style={{
                  fontFamily: "PoppinsSemiBold",
                  fontStyle: "normal",
                  letterSpacing: 1.2,
                  color: "#2e3b4a",
                  fontSize: 18,
                }}>{module.name}</Text>}
              </View>

              {!view && <DangerButton label="Delete Module" onPress={() => {
                const oldModules = [...modules];
                oldModules.splice(index, 1);
                setFormObject({
                  modules: oldModules
                });
              }} />}
            </View>
            {module.lessons && module.lessons.map((lesson, lessonIndex) => {
              return <View key={lessonIndex} row={Platform.OS == 'web'} spread={Platform.OS == 'web'} marginT-10 style={{ width: '100%' }}>
                <View row={Platform.OS == 'web'} style={Platform.OS == 'web' ? {} : { width: '100%' }}>
                  {!view ? <CustomTextField placeholder="Lesson Name" value={lesson.name} onChange={(value) => {
                    const oldModules = [...modules];
                    oldModules[index].lessons[lessonIndex].name = value;
                    setFormObject({
                      modules: oldModules
                    });
                  }} /> : <TouchableOpacity
                    style={{ flexDirection: 'row', alignItems: 'flex-start' }}
                    onPress={() => {
                      setShowLessonModule(true);
                      setLessonModuleIndex(index);
                      setLessonIndex(lessonIndex);
                    }}>
                    {lesson.type == "Video" && <VideoSvg style={{ marginRight: 10 }} />}
                    <View>
                      <Text value style={{
                        fontFamily: 'SourceSansProSemiBold'
                      }}>{lesson.name}</Text>
                      <Text value>{lesson.duration || 0} {lesson.duration_unit}</Text>
                    </View>
                  </TouchableOpacity>}
                  {!view ? <SecondaryButton style={{
                    marginLeft: Platform.OS == 'web' ? 10 : 0,
                  }} label="Edit Content" onPress={() => {
                    setShowLessonModule(true);
                    setLessonModuleIndex(index);
                    setLessonIndex(lessonIndex);
                  }} /> : null}
                </View>
                {!view && <DangerButton label="Delete" onPress={() => {
                  const oldModules = [...modules];
                  oldModules[index].lessons.splice(lessonIndex, 1);
                  setFormObject({
                    modules: oldModules
                  });
                }} />}
              </View>
            })}

            <View left marginT-10>
              {!view && <SecondaryButton label="Add Lesson" onPress={() => {
                const oldModules = [...modules];
                oldModules[index].lessons = oldModules[index].lessons || [];
                oldModules[index].lessons.push({
                  name: "Lesson Name",
                  type: "Video",
                  duration: 0,
                  duration_unit: "Minutes",
                  content: null
                });
                setFormObject({
                  modules: oldModules
                });
              }} />}
            </View>
          </View>
        </Card>
      })}

      <CustomModal
        width={"100%"}
        visible={showLessonModule}
        onClose={() => {
          setShowLessonModule(false);
          setLessonModuleIndex(null);
          setLessonIndex(null);
        }}>
        <ScrollView padding-15 style={{
          minHeight: Dimensions.get('window').height - 80,
        }}>
          <Row>
            <Col width="100%">
              <View row spread style={{ width: "100%" }}>
                <Text h2>Lesson Details</Text>
                <View row spread>
                  {!view && <DangerButton style={{ marginRight: 10 }} label="Delete Lesson" onPress={() => {
                    const oldModules = [...modules];
                    oldModules[lessonModuleIndex].lessons.splice(lessonIndex, 1);
                    setFormObject({
                      modules: oldModules
                    });
                    setShowLessonModule(false);
                    setLessonModuleIndex(null);
                    setLessonIndex(null);
                  }} />}
                  <SecondaryButton label="Close" onPress={() => {
                    setShowLessonModule(false);
                    setLessonModuleIndex(null);
                    setLessonIndex(null);
                  }} />
                </View>
              </View>
            </Col>
            <Col width="100%">
              {Platform.OS == 'ios' ? <View style={{ overflow: 'hidden' }}>
                <View
                  style={{
                    borderStyle: 'dashed',
                    borderWidth: 1,
                    borderColor: '#d9d9d9',
                    margin: -2,
                    marginTop: 10,
                  }}>
                  <View style={{ height: 20, width: 200 }} />
                </View>
              </View> : <View style={{
                borderBottomColor: '#d9d9d9',
                borderBottomWidth: 1,
                width: '100%',
                marginBottom: 0,
                marginTop: 10,
                borderStyle: 'dashed',
              }} />}
            </Col>
            <Col width={Platform.OS == 'web' ? "25%" : "100%"}>
              <View row style={{ width: '100%' }}>
                {Label({ label: "Lesson Name" })}
              </View>
              <View row>
                {!view ? <CustomTextField
                  placeholder="Lesson Name"
                  value={modules[lessonModuleIndex]?.lessons[lessonIndex]?.name}
                  onChange={(value) => {
                    const oldModules = [...modules];
                    oldModules[lessonModuleIndex].lessons[lessonIndex].name = value;
                    setFormObject({
                      modules: oldModules
                    });
                  }} /> : <Text style={{
                    fontFamily: "PoppinsSemiBold",
                    fontStyle: "normal",
                    letterSpacing: 1.2,
                    color: "#2e3b4a",
                    fontSize: 18,
                  }}>{modules[lessonModuleIndex]?.lessons[lessonIndex]?.name}</Text>}
              </View>
            </Col>
            {!view && <Col width={Platform.OS == 'web' ? "25%" : "100%"}>
              <View row style={{ width: '100%' }}>
                {Label({ label: "Lesson Type" })}
              </View>
              <View row>
                <CustomSelect
                  placeholder="Lesson Type"
                  value={modules[lessonModuleIndex]?.lessons[lessonIndex]?.type}
                  onChange={(value) => {
                    const oldModules = [...modules];
                    oldModules[lessonModuleIndex].lessons[lessonIndex].type = value;
                    setFormObject({
                      modules: oldModules
                    });
                  }}
                  options={[
                    { label: "Video", value: "Video" },
                    { label: "PDF Document", value: "PDF Document" },
                  ]} />
              </View>
            </Col>}
            {/* <Col width={Platform.OS == 'web' ? "25%" : "100%"}>
              <View row style={{ width: '100%' }}>
                {Label({ label: "Duration" })}
              </View>
              <View row>
                <CustomNumberInput
                  placeholder="Duration"
                  value={modules[lessonModuleIndex]?.lessons[lessonIndex]?.duration}
                  onChange={(value) => {
                    const oldModules = [...modules];
                    oldModules[lessonModuleIndex].lessons[lessonIndex].duration = value;
                    setFormObject({
                      modules: oldModules
                    });
                  }} />
              </View>
            </Col>
            <Col width={Platform.OS == 'web' ? "25%" : "100%"}>
              <View row style={{ width: '100%' }}>
                {Label({ label: "Duration Unit" })}
              </View>
              <View row>
                <CustomSelect
                  placeholder="Duration Unit"
                  value={modules[lessonModuleIndex]?.lessons[lessonIndex]?.duration_unit}
                  onChange={(value) => {
                    const oldModules = [...modules];
                    oldModules[lessonModuleIndex].lessons[lessonIndex].duration_unit = value;
                    setFormObject({
                      modules: oldModules
                    });
                  }}
                  options={[
                    { label: "Minutes", value: "Minutes" },
                    { label: "Hours", value: "Hours" },
                  ]}
                />
              </View>
            </Col> */}
            {/* <Col width="100%">
              {Label({ label: "Duration means the amount of time after which the lesson will be marked as completed. Eg. If you set the duration as 10 minutes, then the lesson will be marked as completed ONLY after 10 minutes of the user watching the video or reading the PDF document." })}
            </Col> */}
            <Col width="100%">
              <View style={{ width: "100%" }}>
                {(modules[lessonModuleIndex]?.lessons[lessonIndex]?.type == "Video" && modules[lessonModuleIndex]?.lessons[lessonIndex]?.content) && <Video
                  style={{ width: "100%", height: 300 }}
                  videoStyle={{ width: "100%", height: 300 }}
                  source={{
                    uri: modules[lessonModuleIndex]?.lessons[lessonIndex]?.content,
                  }}
                  resizeMode={ResizeMode.CONTAIN}
                  useNativeControls
                />}
                {!view && <>
                  {modules[lessonModuleIndex]?.lessons[lessonIndex]?.type == "Video" && <CustomUpload
                    value={modules[lessonModuleIndex]?.lessons[lessonIndex]?.content}
                    mimeType="video/*"
                    moduleName={"Courses"}
                    onChange={(value) => {
                      const oldModules = [...modules];
                      oldModules[lessonModuleIndex].lessons[lessonIndex].content = value;
                      setFormObject({
                        modules: oldModules
                      });
                    }} />}
                  {modules[lessonModuleIndex]?.lessons[lessonIndex]?.type == "PDF Document" && <CustomUpload
                    value={modules[lessonModuleIndex]?.lessons[lessonIndex]?.content}
                    mimeType="application/pdf"
                    moduleName={"Courses"}
                    onChange={(value) => {
                      const oldModules = [...modules];
                      oldModules[lessonModuleIndex].lessons[lessonIndex].content = value;
                      setFormObject({
                        modules: oldModules
                      });
                    }} />}
                </>}
              </View>
            </Col>
          </Row>
        </ScrollView>
      </CustomModal>

      {!view && <View left>
        <PrimaryButton label="Add Module" onPress={() => {
          const oldModules = [...modules];
          oldModules.push({
            name: "Module Name",
          });
          setFormObject({
            modules: oldModules
          });
        }} />
      </View>}
    </View>
  }

  const formFields = [
    {
      type: 'divider',
      heading: 'Course Details',
      visible: true,
      span: 24,
    },
    {
      label: 'Name',
      key: 'name',
      type: 'text',
      placeholder: 'Enter the Course Name',
      visible: true,
      width: '25%',
      required: true,
    },
    {
      label: 'Designations',
      key: 'designation_ids',
      type: 'select',
      placeholder: 'Select the Designations who can access this course',
      visible: view ? false : true,
      width: '75%',
      required: true,
      options: (response.Designations || []).map((designation) => {
        return {
          label: designation.name,
          value: designation._id,
        }
      })
    },
    {
      visible: true,
      width: '100%',
      type: "custom",
      component: CourseContent,
    }
  ];

  const CustomFields = response.CustomFields;

  if (CustomFields && CustomFields.length > 0) {
    CustomFields.forEach((field) => {
      formFields.push({
        label: field.name,
        key: 'cf.' + field.key,
        type: field.type,
        placeholder: field.placeholder,
        visible: true,
        width: '25%'
      });
    });
  }

  return formFields;
}

export const courseMobileCard = (item, index, getFieldValue) => {
  return <Card flex margin-20 padding-15 className="hh" style={{ height: 100, marginVertical: 10, flexDirection: 'row', flexWrap: 'wrap' }}>
    <View>
      <Text>TEST</Text>
      <Text style={{ marginBottom: 5 }}>{getFieldValue(item, 'name') ? "" + getFieldValue(item, 'name') : ""}</Text>
    </View>
  </Card>;
}

export const courseMain = {
  fields: coursefields,
  mobileCard: null
}